// https://github.com/biati-digital/glightbox
import 'glightbox/dist/css/glightbox.css';
import GLightbox from 'glightbox';


//standard lightbox
const lightbox = GLightbox();

//search box header
$(document).ready(function() {


    const team = GLightbox({
        touchNavigation: false,
        touchFollowAxis: false,
        keyboardNavigation: false,
        selector: ".ansprechperson--modul",
        zoomable: false,
        draggable: false,
        height: 'auto',
        skin: 'cover-ansprechperson',
        closeButton: true,
        closeOnOutsideClick: true
    });
   
    if ($('.ansprechperson--modul')[0]) {
        $(window).on('resize', function () {
            resizeGlightboxContainer();
        });
    }
    team.on('open', () => {
        resizeGlightboxContainer();
    });

});
function resizeGlightboxContainer() {
    var newHeight = window.innerHeight;
    $('.glightbox-cover-ansprechperson .ginner-container').css('max-height', newHeight );
}